<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @confirm="handleConfirm" @close="alertContent=null"/>
    <div id="rules-container">
        <div id="rules">
            <div id="direction">
                <ul>
                    <li>خانه</li>
                    <li><img width="7" height="11" src="../assets/new/New/Icon/LeftBreadcrumb.png" alt=""></li>
                    <li>قوانین و مقررات</li>
                </ul>
            </div>
            <div id="title">
                قوانین و مقررات
                <span>
                کانادا از ایران
            </span>
            </div>
            <div id="main-content"  v-if="infos" v-html="infos.explain"></div>

            <div id="footer-content"  v-if="infos">
                <div class="row">
                    <div class="small-div col-lg-4 col-md-4 col-sm-12"  v-if="$store.state.socialMediaLinks.telegram">
                        <a :href="$store.state.socialMediaLinks.telegram"  target="_blank">
                            <span>کانال تلگرام کانادا از ایران</span>
                            <img width="80" height="80" src="../assets/new/New/Logo.png" alt="">
                        </a>
                    </div>
                    <div class="small-div col-lg-4 col-md-4 col-sm-12" v-if="$store.state.socialMediaLinks.instagram">
                        <a :href="$store.state.socialMediaLinks.telegram"  target="_blank">
                            <span>اینستاگرام کانادا از ایران</span>
                            <img width="80" height="80" src="../assets/new/New/instagram.png" alt="">
                        </a>
                    </div>
                    <div class="small-div col-lg-4 col-md-4 col-sm-12">
                        <a v-on:click="$router.push('/user-signup')">
                            <span>فرم ارزشیابی رایگان</span>
                            <img width="80" height="80" src="../assets/new/New/Icon/clipboard.png" alt="">
                        </a>
                    </div>
                </div>
            </div>

        </div>
        <div v-if="loadingMood">
            <img style="height: auto;margin-top: -100px;width: 50%" src="../assets/loader/output-onlinegiftools.gif" alt="loader">
        </div>
    </div>
</template>

<script>
    import Alert from '../components/Alert'
    import axios from 'axios'
    export default {
        name: "Rules",
        components:{
            Alert,
        },
        data(){
            return {
                alertContent: null,
                loadingMood: false,
                infos:null,
            }
        },
        methods:{
            async getPageInfos() {
                try {
                    this.loadingMood = true;
                    let response = await axios.get('api/getPageInfos/rulesPage',
                        {
                            headers:
                                {
                                    "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                }
                        });
                    this.loadingMood = false;
                    this.infos = response.data.results;

                } catch (error) {
                    console.log(error)
                }
            },
        },
        mounted() {
            this.getPageInfos();
        },
    }
</script>

<style lang="scss" scoped>
    #footer-content{
        overflow: hidden;
    }
    #rules-container{
        width: 100%;
        height: auto;
        background-color: white;
    }
    #main-content{
        padding-top: 50px;
        padding-bottom: 50px;
        text-align: right;
        overflow: hidden;
    }
    #direction>ul{
        padding: 0;
       text-align: right;
        list-style-type: none;
    }
    #direction>ul>li{
        min-width: 30px;
        width: auto;
        text-align: center;
        height: auto;
        display: inline-block;
    }
    #direction>ul>li:nth-child(3){
        opacity: 0.3;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }




    .small-div{
        min-height: 140px;
        a{
            padding: 10px;
            margin-top: 15px;
            width: 100%;
            height: 140px;
            background-color: #162336;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10px;
            span{
                font-size: 16px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #ffffff;
                margin: 20px;
            }
            image{

            }
        }
    }
    #rules{
        max-width: 1120px;
        width: 100%;
        background-color: white!important;
        margin: auto;
        padding: 50px 15px;






        #title{
            width: 100%;
            text-align: right;
            font-size: 30px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1a1a1a;
            span{
                color: #cc171d;
            }
        }
    }
</style>